(() => {
  if (!window.matchMedia('(max-width: 1023px)').matches) return;

  function initSwiperVariationB(container) {
    const el = container.querySelector('.swiper.shop-look__list');

    const swiper = new Swiper(el, {
      slidesPerView: 'auto',
      loop: true,
      breakpoints: {
        500: {
          slidesPerGroupAuto: true,
          loop: false
        }
      }
    });

    if (typeof checkShopLookVisibility === 'function') {
      swiper.on('slideNextTransitionStart', checkShopLookVisibility);
      swiper.on('slidePrevTransitionStart', checkShopLookVisibility);
    }
  }

  async function definitionOfTestVariation() {
    const container = document.querySelector('[data-stl]');
    if (!container) return;

    if (window.gbInitPromise) await window.gbInitPromise;

    if (
      window.gb?.getFeatureValue('us-shop-the-look-visual', 'Variation 1') ===
      'Variation 2'
    ) {
      const res = await fetch(
        `${location.pathname}?view=shop-the-look-b-variation`,
        { credentials: 'same-origin' }
      );

      if (res.ok) {
        container.innerHTML = await res.text();
        initSwiperVariationB(container);
        document.body.dispatchEvent(
          new CustomEvent('shop_the_look_update', { bubbles: true })
        );
      }
    } else {
      document
        .querySelector('.shop-look__wrap.tw-hidden')
        .classList.remove('tw-hidden');
    }

    container.classList.remove('tw-min-h-[502px]');
  }

  window.addEventListener('pageshow', e => {
    if (!e.persisted) return;
    const container = document.querySelector('[data-stl]');
    if (container) initSwiperVariationB(container);
  });
})();
